import { isRESTAPIError } from './RESTAPIError';

/** True when `error` is a REST API error carrying the given HTTP status code. */
export function isRESTAPIErrorWithStatus(error: unknown, status: number): boolean {
  return isRESTAPIError(error) && error.status === status;
}
